export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const STATUS_STYLES = {
  "Ready to Move": "bg-gold text-forest",
  "Under Construction": "bg-white/90 text-slate-700",
  Resale: "bg-forest text-gold",
};

export const PROJECTS = [
  {
    name: "The Storeys",
    config: "4 / 5 BHK Single-Storeyed & Duplex Homes",
    status: "Ready to Move",
    price: "₹4.26 Cr onwards",
    sizes: "3541 – 5998 sq. ft.",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys/carousel-images/outdoor/the-storey-1.ashx",
    tags: ["Platinum-rated homes", "23-ft ceiling duplexes", "Belvedere Club membership"],
  },
  {
    name: "Paarijat",
    config: "4 BHK Premium Homes",
    status: "Ready to Move",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/paarijat/thumbnails/thumbnail.ashx",
    tags: ["Ready to move in", "Premium tower living", "Club access"],
  },
  {
    name: "La Marina",
    config: "4 BHK & 5 BHK Penthouses",
    status: "Ready to Move",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/la-marina/carousel-images/thumbnail-image/thumbnail.ashx",
    tags: ["Waterfront living", "Penthouse decks", "Golf-side address"],
  },
  {
    name: "Water Lily",
    config: "5 BHK Duplex Penthouses",
    status: "Ready to Move",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/water-lily/thumbnail.ashx",
    tags: ["Duplex penthouses", "Lake-side greens", "Private terraces"],
  },
  {
    name: "Aster NEO",
    config: "2 BHK #Smartments",
    status: "Ready to Move",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/aster-neo/1920x1080/1920x1080-cam_03-n.ashx",
    tags: ["Smart home automation", "~70% open greens", "Vanishing-edge pool"],
  },
  {
    name: "The West Park",
    config: "Luxury Villas",
    status: "Ready to Move",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/west-park/highlight/adobestock_633152870.ashx",
    tags: ["Private villas", "Gated enclave", "Club access"],
  },
  {
    name: "The Storeys Infinity",
    config: "4 BHK Apartments & 5 BHK Penthouses",
    status: "Under Construction",
    price: "₹3.5 Cr onwards",
    sizes: "2422 – 5019 sq. ft.",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys-infinity/gallery/01.ashx",
    tags: ["Canal + golf views", "11-ft slab heights", "Private lift foyers"],
  },
  {
    name: "The Storeys Golf Coast",
    config: "4 BHK Simplex & 5 BHK Duplex",
    status: "Under Construction",
    price: "Price on Request",
    sizes: "3501 – 6466 sq. ft.",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys-golf-coast/banner-(1).ashx",
    tags: ["Single floor, single home", "Golf course views", "White glove services"],
  },
  {
    name: "Ambrosia",
    config: "4 BHK Ultra-Luxury Apartments",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/ambrosia/thumbnails/thumbnail-1.ashx",
    tags: ["Ultra-luxury specifications", "Signature tower", "Club access"],
  },
  {
    name: "The North Park",
    config: "4 BHK Villas",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-north-park/exterior/exterior/villa-b-street-view-1.ashx",
    tags: ["Private garden & pool", "Gated villa enclave", "Exclusive club"],
  },
  {
    name: "Belrosa",
    config: "4 & 5 BHK Apartments · 5 & 6 BHK Duplexes",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/belrosa/exterior/entrance-gate-view.ashx",
    tags: ["Grand duplexes", "Canal-facing homes", "Premium clubhouse"],
  },
  {
    name: "Skyline",
    config: "4 BHK Uberments",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/skyline/gallary-image/skyline-1-(1).ashx",
    tags: ["Uber-luxury apartments", "Sky residences", "Panoramic views"],
  },
  {
    name: "Embrace",
    config: "3 BHK Lifestyle Homes",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/embrace/optimize-exterior-jpg/1920x1080-exterior/1920x1080-birds-eye-view.ashx",
    tags: ["Lifestyle homes", "Multipurpose lawns", "Family community"],
  },
  {
    name: "Greenfield",
    config: "3 BHK Apartments & 4 BHK Penthouses",
    status: "Under Construction",
    price: "Price on Request",
    img: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/shivalik-greenfiled/render-images/cam-11_11zon.ashx",
    tags: ["270° open views", "Penthouse collection", "Green living"],
  },
  {
    name: "Resale Units",
    config: "2 – 5 BHK · Across Shantigram",
    status: "Resale",
    price: "Best Market Rates",
    img: "https://images.unsplash.com/photo-1720247520862-7e4b14176fa8?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Verified owner-listed units in Aster, Paarijat, The Meadows, La Marina and more — clear titles, genuine pricing and end-to-end assistance.",
  },
];
